import React, { useMemo } from 'react';
import moment from 'moment';
import { Input, Button, PaperClip, Select, DatePicker, Textarea, FallbackImage, CheckboxTable } from 'components';
import { AuthService, UserService } from 'services';
import { Globals, Constants, Socket, SocketEvents } from 'utils';
import { WhiteImage } from 'assets/img';
import { TimeIcon, AddIcon, CloseIcon, ContactVideoCallIcon, ContactCallIcon, ContactMessageIcon, PDFIcon, FileIcon } from 'assets/icons';

interface Props {
  onClose?: any;
  item?: any;
  document_types: any;
  phonecodes: any;
  specialities: any;
  states: any;
}

const specializations = [
  { value: Constants.USER.AREAS_SPECIALIZATION.PEQ_ANIMALES.id.toString(), label: Constants.USER.AREAS_SPECIALIZATION.PEQ_ANIMALES.name },
  { value: Constants.USER.AREAS_SPECIALIZATION.GRA_ANIMALES.id.toString(), label: Constants.USER.AREAS_SPECIALIZATION.GRA_ANIMALES.name },
  { value: Constants.USER.AREAS_SPECIALIZATION.EXOTICOS.id.toString(), label: Constants.USER.AREAS_SPECIALIZATION.EXOTICOS.name },
];

const animalList = Object.values(Constants.AFFILIATE_ANIMALS).map(item => ({ value: String(item.id), label: item.name }));
const serviceList = Object.values(Constants.SERVICES).map(item => ({ value: String(item.id), label: item.name }));

const weekDays = [
  { value: '1', label: 'Lun' },
  { value: '2', label: 'Mar' },
  { value: '3', label: 'Mié' },
  { value: '4', label: 'Jue' },
  { value: '5', label: 'Vie' },
  { value: '6', label: 'Sáb' },
  { value: '7', label: 'Dom' },
];

const contact_methods = [
  { id: 1, icon: ContactVideoCallIcon, name: 'Video llamada' },
  { id: 2, icon: ContactCallIcon, name: 'Llamada telefónica' },
  { id: 3, icon: ContactMessageIcon, name: 'Mensaje de texto' },
];

const TAB = {
  DATA: 1,
  PRODUCTS: 2,
}

const initialProduct = {
  name: 'Nuevo producto',
  image: '',
  image_blob: '',
};

interface FormI {
  level_id?: number;
  affiliate_type?: number;
  name: string;
  email: string;
  document: string;
  address: string;
  document_type_id: any;
  phonecode_id: any;
  phone: string;
  state_id: string;
  city_id: string;
  photo: any;
  photo_blob: string;
  description: string;
  seller_code: string;
  // Datos bancarios
  bank_account: {
    bank_id: number;
    number: string;
    phonecode_id: number;
    phone: string;
    document_type_id: number;
    document: string;
  };
  // Datos de persona de contacto
  contact_person_name: string;
  contact_person_email: string;
  contact_person_doc_type_id: string;
  contact_person_document: string;
  contact_person_phone_code_id: string;
  contact_person_phone: string;
  // Datos profesionales
  medical_number: string;
  university_title: any;
  medical_carnet: any;
  insai_file: any;
  mpps_file: any;
  speciality_id: string;
  specialties: any[];
  language_id: string;
  languages: string[];
  years_experience: string;
  // Áreas de especialización
  areas_specialization: string[];
  animal_id: string;
  animal_name: string;
  animals_affiliate: any[];
  service_id: string;
  service_name: string;
  services: any[];
  category_id: string;
  category_name: string;
  categories: any[];
  vet_name: string;
  veterinarians: any[];
  // Horario de atención
  consultation: {
    init_hour: string;
    end_hour: string;
    days: string[];
    teleconsultation_rate_id: string;
    home_service: string;
    emergency_service: string;
    delivery_service: string;
    contact_methods: string[];
  };
  // Productos
  products: {
    name: string;
    image: any;
    image_blob: string;
  }[];
}

interface StateI {
  tab: number;
  showNewSpeciality: boolean;
  showNewLanguage: boolean;
  showNewAnimal: boolean;
  showNewService: boolean;
  showNewCategory: boolean;
  showNewVet: boolean;
  form: FormI;
  specialties: any[];
  languages: any[];
  categories: any[];
  states: any[];
  cities: any[];
  banks: any[];
  teleconsultationRates: any[];
}

class ModalCreate extends React.Component<Props> {

  state: StateI = {
    tab: TAB.DATA,
    showNewSpeciality: false,
    showNewLanguage: false,
    showNewAnimal: false,
    showNewService: false,
    showNewCategory: false,
    showNewVet: false,
    form: {
      name: '',
      email: '',
      document: '',
      address: '',
      document_type_id: '',
      phonecode_id: '',
      phone: '',
      state_id: '',
      city_id: '',
      photo: '',
      photo_blob: '',
      description: '',
      seller_code: '',
      // Datos bancarios
      bank_account: {
        bank_id: 0,
        number: '',
        phonecode_id: 0,
        phone: '',
        document_type_id: 0,
        document: '',
      },
      // Datos de persona de contacto
      contact_person_name: '',
      contact_person_email: '',
      contact_person_doc_type_id: '',
      contact_person_document: '',
      contact_person_phone_code_id: '',
      contact_person_phone: '',
      // Datos profesionales
      university_title: null,
      medical_carnet: null,
      insai_file: null,
      mpps_file: null,
      speciality_id: '',
      specialties: [],
      language_id: '',
      languages: [],
      years_experience: '',
      medical_number: '',
      // Áreas de especialización
      areas_specialization: [],
      animal_id: '',
      animal_name: '',
      animals_affiliate: [],
      service_id: '',
      service_name: '',
      services: [],
      category_id: '',
      category_name: '',
      categories: [],
      vet_name: '',
      veterinarians: [],
      // Horario de atención
      consultation: {
        init_hour: '',
        end_hour: '',
        days: [],
        teleconsultation_rate_id: '',
        home_service: '',
        emergency_service: '',
        delivery_service: '',
        contact_methods: [],
      },
      products: [],
    },
    specialties: [],
    languages: [],
    categories: [],
    states: [],
    cities: [],
    banks: [],
    teleconsultationRates: [],
  }

  componentDidMount() {
    this.getSelects();
    if (this.props.item) this.getInfo();
  }

  getSelects = async () => {
    try {
      const res: any = await UserService.admin.getSelects();

      const toSelect = (values?: any[]) => {
        return (values ?? [])?.map((i: any) => ({ value: String(i.id), label: i.name })) || [];
      }

      this.setState({
        specialties: res.specialties?.map((i: any) => ({ value: i.name, label: i.name })) || [],
        languages: toSelect(res.languages)?.sort((a: any, b: any) => a.label.localeCompare(b.label)) || [],
        categories: toSelect(res.categories),
        states: res.states || [],
        teleconsultationRates: res.teleconsultationRates?.map((i: any) => ({ value: String(i.id), label: Globals.formatMiles(i.amount, true, '$') })) || [],
      });

    } catch (error) {
      console.log(error)
    }
  }

  getInfo = async () => {
    try {
      const user: any = await UserService.admin.find({ id: this.props.item?.id });
      const banks: any = await UserService.admin.getBanks();

      if (user?.consultation) {
        const days = String(user?.consultation?.days).split(',');
        const methods = String(user?.consultation?.contact_methods).replace(/\[|\]/g, '').split(',');
        user.consultation.days = days;
        user.consultation.contact_methods = methods;
      }

      this.setState({
        form: {
          ...this.state.form,
          level_id: user?.level_id,
          affiliate_type: user?.affiliate_type,
          name: user?.name,
          email: user?.email,
          document_type_id: user?.document_type_id,
          document: user?.document || '',
          phonecode_id: user?.phonecode_id,
          phone: user?.phone || '',
          state_id: user?.state_id || '',
          city_id: user?.city_id || '',
          address: user?.address || '',
          photo_blob: user?.photo ? Globals.fromPhotos(user?.photo) : '',
          description: user?.description || '',
          seller_code: user?.seller?.code || '',
          // Datos bancarios
          bank_account: {
            bank_id: user?.bank_account?.bank_id || '',
            number: user?.bank_account?.number || '',
            phonecode_id: user?.bank_account?.phonecode_id || '',
            phone: user?.bank_account?.phone || '',
            document_type_id: user?.bank_account?.document_type_id || '',
            document: user?.bank_account?.document || '',
          },
          // Persona de contacto
          contact_person_name: user?.contact_person_name || '',
          contact_person_email: user?.contact_person_email || '',
          contact_person_doc_type_id: user?.contact_person_doc_type_id || '',
          contact_person_document: user?.contact_person_document || '',
          contact_person_phone_code_id: user?.contact_person_phone_code_id || '',
          contact_person_phone: user?.contact_person_phone || '',
          // Datos profesionales
          university_title: user?.professional_data?.university_title || '',
          medical_carnet: user?.professional_data?.medical_carnet || '',
          insai_file: user?.professional_data?.insai || '',
          mpps_file: user?.professional_data?.mpps || '',
          specialties: user?.user_specialties?.map((i: any) => i.name) || [],
          languages: user?.languages?.map((i: any) => String(i.language)) || [],
          years_experience: user?.professional_data?.years || '',
          medical_number: user?.professional_data?.medical_number || '',
          // Áreas de especialización
          areas_specialization: user?.areas_specialization?.map((i: any) => String(i.area)) || [],
          animals_affiliate: user?.affiliate_animals?.map((i: any) => ({ type: String(i.type), type_text: i.type_txt, name: i.name })) || [],
          services: user?.user_services?.map((i: any) => ({ type: String(i.type), type_text: i.type_txt, name: i.name })) || [],
          categories: user?.categories?.map((i: any) => String(i.category_id)) || [],
          veterinarians: user?.affiliate_veterinarians?.map((i: any) => ({ id: String(i.id), name: i.name })) || [],
          // Horario de atención
          consultation: {
            init_hour: Globals.parseTime(user?.consultation?.init_hour || ''),
            end_hour: Globals.parseTime(user?.consultation?.end_hour || ''),
            days: user?.consultation?.days || [],
            teleconsultation_rate_id: user?.consultation?.teleconsultation_rate_id || '',
            home_service: user?.consultation?.home_service || 0,
            emergency_service: user?.consultation?.emergency_service || 0,
            delivery_service: user?.consultation?.delivery_service || 0,
            contact_methods: user?.consultation?.contact_methods || [],
          },
          products: user?.products?.map((i: any) => ({
            name: i.name,
            image: i.image,
            image_blob: i.image,
          })) || [],
        },
        banks: banks.banks || [],
      }, () => this.getCities());

    } catch (error) {
      console.log(error);
    }
  }

  getCities = async () => {
    const res: any = await AuthService.getCities({ state_id: this.state.form.state_id });
    this.setState({ cities: res.cities });
  }

  change = (e: any, callback = () => { }) => {
    const target = e.target ?? e.currentTarget;
    this.setState((s: StateI) => ({
      form: { ...s.form, [target.name]: target.value }
    }), callback);
  }

  changeValue = (target: keyof FormI, value: any, callback = () => { }) => {
    this.setState((s: StateI) => ({ form: { ...s.form, [target]: value } }), callback);
  }

  isValidForm = () => {
    const onError = (msg: string) => {
      Globals.showError(msg);
      return false;
    }

    const { form } = this.state;

    if (!form.name)
      return onError('Debe indicar el nombre');

    if (form.products.length) {
      if (!form.products.some(i => i.name))
        return onError('Debe indicar el nombre de todos los productos');

      if (!form.products.some(i => i.image))
        return onError('Debe subir una foto de todos los productos');
    }

    return true;
  }

  submit = async (e: any) => {
    e.preventDefault();
    if (!this.isValidForm()) return;

    try {
      const { form } = this.state;

      const payload: any = {
        user_id: this.props.item?.id,
        ...form,
        categories: JSON.stringify(form.categories.map(i => Number(i))),
        languages: JSON.stringify(form.languages.map(i => Number(i))),
        specialties: JSON.stringify(form.specialties),
        areas_specialization: JSON.stringify(form.areas_specialization.map(i => Number(i))),
        animals_affiliate: JSON.stringify(form.animals_affiliate),
        services: JSON.stringify(form.services),
        consultation: JSON.stringify({
          ...form.consultation,
          init_hour: form.consultation.init_hour ? moment(form.consultation.init_hour, 'HH:mm:ss').format('HH:mm') : '',
          end_hour: form.consultation.end_hour ? moment(form.consultation.end_hour, 'HH:mm:ss').format('HH:mm') : '',
          days: (form.consultation.days || []).join(','),
        }),
        bank_account: JSON.stringify(form.bank_account),
        products: JSON.stringify(form.products.map(i => ({ name: i.name, image: i.image?.value || i.image || '' }))),
        veterinarians: JSON.stringify(form.veterinarians),
        photo: form.photo?.value || '',
        hasFile: true,
      };

      if (form.products.length) {
        form.products.forEach((i, index) => {
          if (i.image instanceof File) {
            payload[`products[${index}][image]`] = i.image;
          }
        });
      }

      await UserService.admin.createOrUpdate(payload);
      Globals.showSuccess("Se ha modificado el afiliado correctamente");
      Socket.emit(SocketEvents.UPDATE_USER, { user_id: this.props.item?.id });
      this.props.onClose();

    } catch (error) {
      console.log(error)
    }
  }

  setTab = (tab: number) => {
    this.setState({ tab });
  }

  render() {

    const { form, tab } = this.state;
    const isMedic = this.props.item?.affiliate_type === Constants.AFFILIATE_TYPES.MEDIC;
    const isClinic = this.props.item?.affiliate_type === Constants.AFFILIATE_TYPES.CLINIC;
    const isBusiness = this.props.item?.affiliate_type === Constants.AFFILIATE_TYPES.BUSINESS_SERVICE_OR_ADVERTISER;

    return (
      <div id="modal-create-doctor" className="edit">
        <div className="header">
          <p className="title">{!this.props.item ? 'Nuevo' : 'Editar'}</p>
          <button className="close" onClick={this.props.onClose}>
            <img src={CloseIcon} alt="Cerrar" />
          </button>
        </div>

        <div className="tabs">
          <button data-active={String(tab === TAB.DATA)} onClick={() => this.setTab(TAB.DATA)}>
            Datos
          </button>
          <button data-active={String(tab === TAB.PRODUCTS)} onClick={() => this.setTab(TAB.PRODUCTS)}>
            Productos
          </button>
        </div>

        {tab === TAB.DATA && (
          <form className="row" onSubmit={this.submit}>
            <div className="col-md-8">
              <Input
                color="white"
                value={form.name}
                name="name"
                placeholder="Nombre de la Empresa"
                label="Nombre de la Empresa"
                onChange={this.change} />
            </div>
            <div className="col-md-4">
              <div className="container-select">
                <p className="label">RIF</p>
                <div>
                  <Select
                    className="document_type"
                    name="document_type_id"
                    onChange={this.change}
                    value={form.document_type_id}
                    options={this.props.document_types.map((i: any) => ({ value: i.id, label: i.name }))}
                  />
                  <Input
                    type="number"
                    color="white"
                    value={form.document}
                    name="document"
                    placeholder="Documento"
                    onChange={this.change} />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="container-select">
                <p className="label">Teléfono</p>
                <div>
                  <Select
                    name="phonecode_id"
                    onChange={this.change}
                    value={form.phonecode_id}
                    options={this.props.phonecodes.map((i: any) => ({ value: i.id, label: i.name }))}
                  />
                  <Input
                    type="number"
                    color="white"
                    value={form.phone}
                    name="phone"
                    placeholder="Teléfono"
                    onChange={this.change} />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <Input
                color="white"
                value={form.email}
                name="email"
                placeholder="Correo Electrónico"
                label="Correo Electrónico"
                onChange={this.change} />
            </div>
            <div className="col-md-6">
              <Select
                className="speciality_select"
                label="Estado"
                name="state_id"
                value={form.state_id}
                options={this.props.states.map((i: any) => ({ value: i.id, label: i.name }))}
                onChange={(e: any) => {
                  this.changeValue('state_id', e.target.value);
                  this.changeValue('city_id', '', () => this.getCities());
                }}
              />
            </div>
            <div className="col-md-6">
              <Select
                className="speciality_select"
                label="Ciudad"
                disabled={!form.state_id}
                name="city_id"
                onChange={this.change}
                value={form.city_id}
                options={this.state.cities.map((i: any) => ({ value: i.id, label: i.name }))}
              />
            </div>
            <div className="col-md-12">
              <Textarea
                label="Dirección"
                rows={2}
                color="white"
                value={form.address}
                name="address"
                placeholder="Dirección"
                onChange={this.change} />
            </div>

            <div className="col-md-12">
              <hr />
            </div>

            {(isMedic || isClinic) && (
              <>
                <div className="col-md-12">
                  <p className="section-title">Datos bancarios</p>
                </div>
                <div className="col-md-12">
                  <Select
                    className="speciality_select"
                    label="Banco"
                    name="bank_id"
                    onChange={({ target }: any) => this.changeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                    value={form.bank_account.bank_id}
                    options={this.state.banks.map((i: any) => ({ value: i.id, label: i.name }))}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    color="white"
                    label="Número de cuenta"
                    placeholder="Número de cuenta"
                    name="number"
                    value={form.bank_account.number}
                    onChange={({ target }: any) => this.changeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                  />
                </div>
                <div className="col-md-4">
                  <div className="container-select">
                    <p className="label">C.I.</p>
                    <div>
                      <Select
                        className="document_type"
                        name="document_type_id"
                        value={form.bank_account.document_type_id}
                        onChange={({ target }: any) => this.changeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                        options={this.props.document_types.map((i: any) => ({ value: i.id, label: i.name }))}
                      />
                      <Input
                        type="number"
                        color="white"
                        placeholder="Documento"
                        name="document"
                        value={form.bank_account.document}
                        onChange={({ target }: any) => this.changeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="container-select">
                    <p className="label">Teléfono</p>
                    <div>
                      <Select
                        name="phonecode_id"
                        value={form.bank_account.phonecode_id}
                        options={this.props.phonecodes.map((i: any) => ({ value: i.id, label: i.name }))}
                        onChange={({ target }: any) => this.changeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                      />
                      <Input
                        type="number"
                        color="white"
                        name="phone"
                        placeholder="Teléfono"
                        value={form.bank_account.phone}
                        onChange={({ target }: any) => this.changeValue('bank_account', { ...form.bank_account, [target.name]: target.value })}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <hr />
                </div>
              </>
            )}

            {(isBusiness || isClinic) && (
              <>
                <div className="col-md-12">
                  <p className="section-title">Datos de persona de contacto</p>
                </div>
                <div className="col-md-4">
                  <Input
                    color="white"
                    label="Nombre"
                    placeholder="Nombre"
                    name="contact_person_name"
                    value={form.contact_person_name}
                    onChange={this.change} />
                </div>
                <div className="col-md-4">
                  <div className="container-select">
                    <p className="label">C.I.</p>
                    <div>
                      <Select
                        className="document_type"
                        name="contact_person_doc_type_id"
                        value={form.contact_person_doc_type_id}
                        onChange={this.change}
                        options={this.props.document_types.map((i: any) => ({ value: i.id, label: i.name }))}
                      />
                      <Input
                        type="number"
                        color="white"
                        placeholder="Documento"
                        name="contact_person_document"
                        value={form.contact_person_document}
                        onChange={this.change}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="container-select">
                    <p className="label">Teléfono</p>
                    <div>
                      <Select
                        className="document_type"
                        name="contact_person_phone_code_id"
                        value={form.contact_person_phone_code_id}
                        onChange={this.change}
                        options={this.props.phonecodes.map((i: any) => ({ value: i.id, label: i.name }))}
                      />
                      <Input
                        type="number"
                        color="white"
                        placeholder="Teléfono"
                        name="contact_person_phone"
                        value={form.contact_person_phone}
                        onChange={this.change}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <Input
                    color="white"
                    label="Correo Electrónico"
                    placeholder="Correo Electrónico"
                    name="contact_person_email"
                    value={form.contact_person_email}
                    onChange={this.change}
                  />
                </div>

                <div className="col-md-12">
                  <hr />
                </div>
              </>
            )}

            <div className="col-md-12">
              <p className="section-title">Datos profesionales</p>
            </div>
            {isMedic && (
              <div className="col-md-12 files">
                <FileCard
                  label="Título universitario"
                  file={form?.university_title}
                  onChange={e => {
                    if (e.target.files?.length) {
                      this.changeValue('university_title', e.target?.files[0])
                      e.target.value = '';
                    }
                  }}
                />
                <FileCard
                  label="Carnet de Colegio de Médicos Veterinarios"
                  file={form?.medical_carnet}
                  onChange={e => {
                    if (e.target.files?.length) {
                      this.changeValue('medical_carnet', e.target?.files[0])
                      e.target.value = '';
                    }
                  }}
                />
                <FileCard
                  label="Registro en el INSAI"
                  file={form?.insai_file}
                  onChange={e => {
                    if (e.target.files?.length) {
                      this.changeValue('insai_file', e.target?.files[0])
                      e.target.value = '';
                    }
                  }}
                />
                <FileCard
                  label="Registro en el MPPS"
                  file={form?.mpps_file}
                  onChange={e => {
                    if (e.target.files?.length) {
                      this.changeValue('mpps_file', e.target?.files[0])
                      e.target.value = '';
                    }
                  }}
                />
              </div>
            )}
            <div className="col-md-4 d-flex align-items-center">
              <p className="label mr-4">Especialidad</p>
              <div className="btn-add-mini" onClick={() => this.setState({ showNewSpeciality: true })}>
                <img src={AddIcon} alt="Agregar" />
                <span>Agregar</span>
              </div>
            </div>
            {this.state.showNewSpeciality && (
              <div className="col-md-4 select-mb-0">
                <Select
                  className="speciality_select mb-0"
                  name="speciality_id"
                  value={form.speciality_id}
                  options={this.state.specialties?.filter((i: any) => !form.specialties?.includes(i.label))}
                  onChange={e => {
                    const data = form.specialties?.includes(e.target.value)
                      ? form.specialties.filter(i => i !== e.target.value)
                      : form.specialties?.concat([e.target.value]);
                    this.changeValue('specialties', data);
                    this.changeValue('speciality_id', '');
                    this.setState({ showNewSpeciality: false });
                  }}
                />
              </div>
            )}
            <div className="col-md-12 speciality-list">
              {form.specialties?.map((name: any, index: number) => (
                <span
                  key={index}
                  onClick={() => {
                    const data = form.specialties?.filter((item: string) => item !== name);
                    this.changeValue('specialties', data);
                  }}
                >
                  {name}
                </span>
              ))}
            </div>

            {(isMedic || isClinic) && (
              <>
                <div className="col-md-4 d-flex align-items-center">
                  <p className="label mr-4">Idiomas</p>
                  <div className="btn-add-mini" onClick={() => this.setState({ showNewLanguage: true })}>
                    <img src={AddIcon} alt="Agregar" />
                    <span>Agregar</span>
                  </div>
                </div>
                {this.state.showNewLanguage && (
                  <div className="col-md-4 select-mb-0">
                    <Select
                      className="speciality_select mb-0"
                      name="language_id"
                      value={form.language_id}
                      options={this.state.languages?.filter((i: any) => !form.languages?.includes(i.value))}
                      onChange={e => {
                        const data = form.languages?.includes(e.target.value)
                          ? form.languages.filter(i => i !== e.target.value)
                          : form.languages?.concat([e.target.value]);
                        this.changeValue('languages', data);
                        this.changeValue('language_id', '');
                        this.setState({ showNewLanguage: false });
                      }}
                    />
                  </div>
                )}
                <div className="col-md-12 speciality-list">
                  {form.languages?.map((id: any, index: number) => (
                    <span
                      key={index}
                      onClick={() => {
                        const data = form.languages?.filter((item: string) => item !== id);
                        this.changeValue('languages', data);
                      }}
                    >
                      {String(this.state.languages.find((i: any) => i.value === id)?.label)}
                    </span>
                  ))}
                </div>
              </>
            )}
            {isMedic && (
              <>
                <div className="col-md-4">
                  <Input
                    type="number"
                    color="white"
                    label="Años de experiencia"
                    placeholder="Años de experiencia"
                    name="years_experience"
                    value={form.years_experience}
                    onChange={e => this.change(e)}
                  />
                </div>
                <div className="col-md-8">
                  <Input
                    color="white"
                    label="Número de Registro en el Colegio de Médicos Veterinarios"
                    placeholder="Número de Registro en el Colegio de Médicos Veterinarios"
                    name="medical_number"
                    value={form.medical_number}
                    onChange={e => this.change(e)}
                  />
                </div>
              </>
            )}

            <div className="col-md-12">
              <hr />
            </div>

            <div className="col-md-12">
              <p className="section-title">Áreas de especialización</p>
            </div>
            {(isMedic || isClinic) && (
              <>
                <div className="col-md-12 areas">
                  {specializations?.map((item, index) => (
                    <div
                      key={index}
                      className="check-item"
                      onClick={() => {
                        const data = form?.areas_specialization?.includes(item.value)
                          ? form?.areas_specialization?.filter(i => i !== item.value)
                          : form?.areas_specialization?.concat([item.value]);
                        this.changeValue('areas_specialization', data);
                      }}
                    >
                      <CheckboxTable active={form?.areas_specialization?.includes(item.value)} />
                      <p>{item.label}</p>
                    </div>
                  ))}
                </div>
                <div className="col-md-4 d-flex align-items-center">
                  <p className="label mr-4">Animales</p>
                  <div
                    className="btn-add-mini"
                    onClick={() => this.setState({ showNewAnimal: true }, () => this.changeValue('animal_id', ''))}
                  >
                    <img src={AddIcon} alt="Agregar" />
                    <span>Agregar</span>
                  </div>
                </div>
                {this.state.showNewAnimal && (
                  <>
                    <div className="col-md-4 select-mb-0">
                      <Select
                        className="speciality_select mb-0"
                        name="animal_id"
                        value={form.animal_id}
                        onChange={(e) => {
                          this.changeValue('animal_id', e.target.value);
                          if (e.target.value === Constants.AFFILIATE_ANIMALS.OTROS.id.toString()) {
                            this.changeValue('animal_name', '');
                          } else {
                            const item = animalList.find(i => i.value === e.target.value);
                            if (!item) return;
                            this.changeValue('animals_affiliate', form.animals_affiliate.concat([{
                              type: item.value,
                              type_text: item.label,
                              name: null,
                            }]));
                            this.setState({ showNewAnimal: false });
                          }
                        }}
                        options={animalList?.filter((i: any) => {
                          return i.value === Constants.AFFILIATE_ANIMALS.OTROS.id.toString()
                            ? true
                            : !form.animals_affiliate?.some(a => a.type === i.value)
                        })}
                      />
                    </div>

                    {form.animal_id === Constants.AFFILIATE_ANIMALS.OTROS.id.toString() && (
                      <div className="col-md-4 select-mb-0">
                        <label className="datalist">
                          <input
                            name="animal_name"
                            onChange={e => this.changeValue('animal_name', e.target.value)}
                          />
                          <button
                            type="button"
                            onClick={() => {
                              const name = form.animal_name.trim();
                              if (!name) return;

                              // Verifica si el animal ya fue seleccionado
                              const exists = form?.animals_affiliate?.find(i => i.name === name);
                              if (exists) return;

                              this.changeValue('animals_affiliate', form.animals_affiliate.concat([{
                                type: Constants.AFFILIATE_ANIMALS.OTROS.id.toString(),
                                type_text: Constants.AFFILIATE_ANIMALS.OTROS.name,
                                name,
                              }]));
                              this.setState({ showNewAnimal: false });
                            }}
                          >
                            Guardar
                          </button>
                        </label>
                      </div>
                    )}
                  </>
                )}
                <div className="col-md-12 mb-4 speciality-list">
                  {form.animals_affiliate?.map((i: any, index: number) => {
                    const isCustom = i.type === Constants.AFFILIATE_ANIMALS.OTROS.id.toString();

                    return (
                      <span
                        key={index}
                        onClick={() => {
                          const data = form.animals_affiliate?.filter((_: string, idx: number) => idx !== index);
                          this.changeValue('animals_affiliate', data);
                        }}
                      >
                        {isCustom ? i.name : i.type_text}
                      </span>
                    )
                  })}
                </div>

                <div className="col-md-5 d-flex align-items-center">
                  <p className="label mr-4">Servicios que ofrece</p>
                  <div
                    className="btn-add-mini"
                    onClick={() => this.setState({ showNewService: true }, () => this.changeValue('service_id', ''))}
                  >
                    <img src={AddIcon} alt="Agregar" />
                    <span>Agregar</span>
                  </div>
                </div>
                {this.state.showNewService && (
                  <>
                    <div className="col-md-3 select-mb-0">
                      <Select
                        className="speciality_select mb-0"
                        name="service_id"
                        value={form.service_id}
                        onChange={(e) => {
                          this.changeValue('service_id', e.target.value);
                          if (e.target.value === Constants.SERVICES.OTROS.id.toString()) {
                            this.changeValue('animal_name', '');
                          } else {
                            const item = serviceList.find(i => i.value === e.target.value);
                            if (!item) return;
                            this.changeValue('services', form.services.concat([{
                              type: item.value,
                              type_text: item.label,
                              name: null,
                            }]));
                            this.setState({ showNewService: false });
                          }
                        }}
                        options={serviceList?.filter((i: any) => {
                          return i.value === Constants.SERVICES.OTROS.id.toString()
                            ? true
                            : !form.services?.some(a => a.type === i.value)
                        })}
                      />
                    </div>

                    {form.service_id === Constants.SERVICES.OTROS.id.toString() && (
                      <div className="col-md-4 select-mb-0">
                        <label className="datalist">
                          <input
                            list="services"
                            name="animal_name"
                            autoComplete="none"
                            onChange={e => this.changeValue('animal_name', e.target.value)}
                          />
                          <button
                            type="button"
                            onClick={() => {
                              const name = form.animal_name.trim();
                              if (!name) return;

                              // Verifica si el animal ya fue seleccionado
                              const exists = form?.services?.find(i => i.name === name);
                              if (exists) return;

                              this.changeValue('services', form.services.concat([{
                                type: Constants.SERVICES.OTROS.id.toString(),
                                type_text: Constants.SERVICES.OTROS.name,
                                name,
                              }]));
                              this.setState({ showNewService: false });
                            }}
                          >
                            Guardar
                          </button>
                        </label>
                      </div>
                    )}
                  </>
                )}
                <div className="col-md-12 mb-4 speciality-list">
                  {form.services?.map((i: any, index: number) => {
                    const isCustom = i.type === Constants.SERVICES.OTROS.id.toString();

                    return (
                      <span
                        key={index}
                        onClick={() => {
                          const data = form.services?.filter((_: string, idx: number) => idx !== index);
                          this.changeValue('services', data);
                        }}
                      >
                        {isCustom ? i.name : i.type_text}
                      </span>
                    )
                  })}
                </div>
              </>
            )}
            <div className="col-md-4 d-flex align-items-center">
              <p className="label mr-4">Categorías</p>
              <div className="btn-add-mini" onClick={() => this.setState({ showNewCategory: true })}>
                <img src={AddIcon} alt="Agregar" />
                <span>Agregar</span>
              </div>
            </div>
            {this.state.showNewCategory && (
              <div className="col-md-4 select-mb-0">
                <Select
                  className="speciality_select mb-0"
                  name="category_id"
                  value={form.category_id}
                  options={this.state.categories?.filter((i: any) => !form.categories?.includes(i.value) && i.label !== 'Clasificados')} onChange={e => {
                    const data = form?.categories?.includes(e.target.value)
                      ? form?.categories?.filter(i => i !== e.target.value)
                      : form?.categories?.concat([e.target.value]);
                    this.changeValue('categories', data);
                    this.setState({ showNewCategory: false });
                  }}
                />
              </div>
            )}
            <div className="col-md-12 mb-4 speciality-list">
              {form.categories?.map((id: any, index: number) => (
                <span
                  key={index}
                  onClick={() => {
                    const data = form.categories?.filter((item: string) => item !== id);
                    this.changeValue('categories', data);
                  }}
                >
                  {String(this.state.categories.find((i: any) => i.value === id)?.label)}
                </span>
              ))}
            </div>
            {(isClinic || isBusiness) && (
              <>
                <div className="col-md-4 d-flex align-items-center">
                  <p className="label mr-4">Veterinarios</p>
                  <div
                    className="btn-add-mini"
                    onClick={() => this.setState({ showNewVet: true }, () => this.changeValue('vet_name', ''))}
                  >
                    <img src={AddIcon} alt="Agregar" />
                    <span>Agregar</span>
                  </div>
                </div>
                {this.state.showNewVet && (
                  <div className="col-md-4 select-mb-0">
                    <label className="datalist">
                      <input
                        placeholder="Nombre"
                        name="vet_name"
                        onChange={e => this.changeValue('vet_name', e.target.value)}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          const name = form.vet_name.trim();
                          if (!name) return;

                          this.changeValue('veterinarians', form.veterinarians.concat([{ id: '', name }]));
                          this.setState({ showNewVet: false });
                        }}
                      >
                        Guardar
                      </button>
                    </label>
                  </div>
                )}
                <div className="col-md-12 mb-4 speciality-list">
                  {form.veterinarians?.map((i: any, index: number) => (
                    <span
                      key={index}
                      onClick={() => {
                        const data = form.veterinarians?.filter((_: string, idx: number) => idx !== index);
                        this.changeValue('veterinarians', data);
                      }}
                    >
                      {i.name}
                    </span>
                  ))}
                </div>
              </>
            )}

            <div className="col-md-12">
              <p className="section-title">Horario de atención</p>
            </div>
            <div className="col-md-3">
              <DatePicker
                label="Desde"
                showTimeSelect={true}
                showTimeSelectOnly={true}
                timeCaption="Hora"
                calendarIcon={TimeIcon}
                dateFormat="h:mm aa"
                value={form?.consultation?.init_hour ? moment(form.consultation.init_hour, 'HH:mm:ss').toDate() : null}
                onChange={(v: Date) => this.changeValue('consultation', { ...form.consultation, init_hour: moment(v).format('HH:mm:ss') })}
              />
            </div>
            <div className="col-md-3">
              <DatePicker
                label="Hasta"
                showTimeSelect={true}
                showTimeSelectOnly={true}
                timeCaption="Hora"
                calendarIcon={TimeIcon}
                dateFormat="h:mm aa"
                value={form?.consultation?.end_hour ? moment(form.consultation.end_hour, 'HH:mm:ss').toDate() : null}
                onChange={(v: Date) => this.changeValue('consultation', { ...form.consultation, end_hour: moment(v).format('HH:mm:ss') })}
              />
            </div>
            <div className="col-md-6">
              <label className="days-label">Días</label>
              <div className="days">
                {weekDays.map((weekday, wIdx) => {
                  const isSelected = form?.consultation?.days?.includes(weekday.value);
                  return (
                    <div
                      key={wIdx}
                      className="day"
                      data-selected={String(isSelected)}
                      onClick={() => {
                        const data = isSelected
                          ? form?.consultation?.days?.filter(i => i !== weekday.value)
                          : form?.consultation?.days?.concat([weekday.value]);
                        this.changeValue('consultation', { ...form.consultation, days: data });
                      }}
                    >
                      {weekday.label}
                    </div>
                  )
                })}
              </div>
            </div>

            <div className="col-md-3">
              <Select
                label="Costo de consulta"
                className="speciality_select"
                name="teleconsultation_rate_id"
                value={form.consultation.teleconsultation_rate_id}
                options={this.state.teleconsultationRates}
                onChange={(e: any) => this.changeValue('consultation', { ...form.consultation, teleconsultation_rate_id: e.target.value })}
              />
            </div>
            <div className="col-md-8" />
            <div className="col-md-4">
              <div
                className="check-item"
                onClick={() => this.changeValue('consultation', { ...form.consultation, home_service: !form.consultation.home_service })}
              >
                <CheckboxTable active={!!form?.consultation.home_service} />
                <p>Disponible para consultas a domicilio</p>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="check-item"
                onClick={() => this.changeValue('consultation', { ...form.consultation, emergency_service: !form.consultation.emergency_service })}
              >
                <CheckboxTable active={!!form?.consultation.emergency_service} />
                <p>Presta servicio de emergencia 24 horas</p>
              </div>
            </div>
            <div className="col-md-4">
              <div
                className="check-item"
                onClick={() => this.changeValue('consultation', { ...form.consultation, delivery_service: !form.consultation.delivery_service })}
              >
                <CheckboxTable active={!!form?.consultation.delivery_service} />
                <p>Cuenta con servicio de delivery</p>
              </div>
            </div>

            <div className="col-md-12">
              <label className="contact-method-title">Método de contacto</label>
              <div className="contact-method-list">
                {contact_methods.map((cm, cmIdx) => {
                  const isSelected = form.consultation.contact_methods.includes(String(cm.id));
                  return (
                    <div
                      key={cmIdx}
                      className="contact-method"
                      data-selected={String(isSelected)}
                      onClick={() => {
                        const data = isSelected
                          ? form?.consultation?.contact_methods?.filter(i => i !== String(cm.id))
                          : form?.consultation?.contact_methods?.concat([String(cm.id)]);
                        this.changeValue('consultation', { ...form.consultation, contact_methods: data });
                      }}
                    >
                      <img src={cm.icon} alt="Método de contacto" />
                      <span>{cm.name}</span>
                    </div>
                  )
                })}
              </div>
            </div>

            <div className="col-md-12">
              <hr />
            </div>

            <div className="col-md-12">
              <p className="section-title">Información de consulta</p>
            </div>

            <div className="col-md-4">
              <div className="container-image">
                <PaperClip
                  className="paperclip-image"
                  value={form.photo}
                  onChange={(e: any) => {
                    this.changeValue('photo', e.target);
                    this.changeValue('photo_blob', URL.createObjectURL(e.target.value));
                  }}
                >
                  <FallbackImage
                    src={form.photo?.dataURL || form.photo_blob}
                    placeholder={WhiteImage}
                    className="selected-image"
                    placeholderClassName="selected-image inactive"
                    alt="Logo"
                  />
                </PaperClip>
                <p className="photo-title">Imagen publicitaria</p>
              </div>
            </div>

            <div className="col-md-8">
              <Textarea
                label="Descripción de su empresa"
                rows={2}
                color="white"
                value={form.description}
                name="description"
                placeholder="Descripción de su empresa"
                onChange={this.change}
              />

              <Input
                color="white"
                value={form.seller_code}
                name="seller_code"
                placeholder="Código del vendedor"
                label="Código del vendedor"
                onChange={this.change}
              />
            </div>

            {/* <div className="col-md-6">
              <Input
                type="password"
                color="white"
                value={ this.state.form.password }
                name="password" 
                placeholder="Contraseña"
                label={ this.props.item != null ? 'Cambiar contraseña (Opcional)' : 'Contraseña' }
                onChange={ this.change } />
            </div>
            <div className="col-md-6">
              <Input
                type="password"
                color="white"
                value={ this.state.form.password_confirmation }
                name="password_confirmation" 
                placeholder="Repetir Contraseña"
                label="Repetir Contraseña"
                onChange={ this.change } />
            </div> */}

            <div className="col-12 mt-3">
              <div className="row row-buttons">
                <div className="col-md-6 text-center">
                  <Button type="button" className="btn-close" onClick={() => this.props.onClose()}>
                    Cerrar
                  </Button>
                </div>
                <div className="col-md-6 text-center">
                  <Button type="submit">
                    Guardar
                  </Button>
                </div>
              </div>
            </div>
          </form>
        )}

        {tab === TAB.PRODUCTS && (
          <>
            <div className="btn-add-mini mb-3" onClick={() => this.changeValue('products', form.products.concat([Globals.clone(initialProduct)]))}>
              <img src={AddIcon} alt="Agregar" />
              <span>Agregar</span>
            </div>

            <div className="products">
              {form?.products?.map((i: any, index: number) => (
                <div key={index} className="product">
                  <label className="product-wrapper">
                    <FallbackImage
                      src={i?.image_blob}
                      placeholder={WhiteImage}
                      className="product-image"
                      placeholderClassName="product-image"
                    />
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={e => {
                        const file = e.target.files?.[0];
                        if (!file) return;
                        const data = form.products.map((i: any, idx: number) => (
                          idx === index ? { ...i, image: file, image_blob: URL.createObjectURL(file) } : i
                        ));
                        this.changeValue('products', data);
                      }}
                    />
                  </label>
                  <Input
                    color="white name"
                    name="name"
                    value={i.name}
                    onChange={e => {
                      const data = form.products.map((i: any, idx: number) => (
                        idx === index ? { ...i, name: e.target.value } : i
                      ));
                      this.changeValue('products', data)
                    }}
                  />
                </div>
              ))}

              {!form?.products?.length && (
                <p className="empty">No tiene productos</p>
              )}
            </div>
          </>
        )}
      </div>
    )
  }
}

interface FileCardProps {
  label: string
  file?: any
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FileCard = ({ label, file, onChange }: FileCardProps) => {
  const { blob, fileName, isPDF } = useMemo(() => {
    if (!file) return {
      blob: null,
      fileName: 'Subir documento',
      isPDF: false,
    };

    const length = String(file?.name || file?.type || file || '').length;
    const isPDF = String(file?.name || file).endsWith('pdf');
    let fileName = String(file?.name || file).substring(length - 12);
    if (fileName === 'null') fileName = '';

    return {
      blob: file instanceof Blob ? URL.createObjectURL(file) : null,
      fileName: fileName ? '...' + fileName : 'Subir documento',
      isPDF,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  return (
    <label className="file">
      <label>{label}</label>
      <div className="file-card">
        <div className="photo-wrapper">
          {!isPDF && (
            <FallbackImage
              key={label + ' ' + fileName}
              src={blob || file}
              placeholder={FileIcon}
              className="file-image"
              placeholderClassName="empty"
              alt={fileName}
            />
          )}
          {!!file && isPDF && (
            <img className="pdf" src={PDFIcon} alt="Documento" />
          )}
        </div>
        <p className="filename">{fileName}</p>
      </div>
      {onChange && (
        <input type="file" accept="image/*, application/pdf" hidden onChange={onChange} />
      )}
    </label>
  )
}

export default ModalCreate;
